import { loadStripe, type Stripe } from '@stripe/stripe-js'

import { config } from '~/config/env'

let stripePromise: Promise<Stripe | null> | null = null
export const getStripe = () => {
  if (!stripePromise) stripePromise = loadStripe(config.VITE_STRIPE_PUBLIC_KEY)

  return stripePromise
}
